export interface SpecialProduct {
  brand: string;
  brandLogo: string;
  type: "ducted" | "split" | "multi";
  model: string;
  image: string;
  capacity: string;
  badge?: "BEST SELLER" | "ON SALE";
  capacityOptions: string[];
  oldPrice?: string;
  newPrice?: string;
  priceNote?: string;
  outlets?: string;
  suitableFor?: string;
  terms: string[];
}

export const specialProducts: SpecialProduct[] = [
  // DUCTED SYSTEMS
  {
    brand: "Daikin",
    brandLogo: "https://airconditioningguys.com.au/uploads/brand_logo/acg_partner1.png",
    type: "ducted",
    model: "FDYAN71AV1",
    image: "https://airconditioningguys.com.au/uploads/ac_product/image-17.png",
    capacity: "7.1 KW",
    badge: "BEST SELLER",
    capacityOptions: ["7.1 KW", "10 KW", "12.5 KW", "14 KW", "16 KW"],
    outlets: "3x Round outlets",
    priceNote: "Pricing includes GST",
    terms: [
      "5 years warranty on parts and labour.",
      "Standard Home requirements, Single story home, Pitch roof, Standard gyprock ceilings.",
      "Outdoor unit positioned on pvc slab, pvc mounting blocks, or rubber feet.",
      "ACG offer 5 year installation warranty.",
      "Sydney metro.",
      "Power included.",
      "Electrical Work Required May Incur Addition Costs",
    ],
  },
  {
    brand: "Fujitsu",
    brandLogo: "https://airconditioningguys.com.au/uploads/brand_logo/system-menu4.png",
    type: "ducted",
    model: "ARTG24LMLC",
    image: "https://airconditioningguys.com.au/uploads/ac_product/image-22.png",
    capacity: "7.1 KW",
    badge: "BEST SELLER",
    capacityOptions: ["7.1 KW", "10 KW", "12.5 KW"],
    outlets: "3x Round outlets",
    priceNote: "Pricing includes GST",
    terms: [
      "5 years warranty on parts and labour.",
      "Standard Home requirements, Single story home, Pitch roof, Standard gyprock ceilings.",
      "Outdoor unit positioned on pvc slab, pvc mounting blocks, or rubber feet.",
      "ACG offer 5 year installation warranty.",
      "Sydney metro.",
      "Power included.",
      "Electrical Work Required May Incur Addition Costs",
    ],
  },
  {
    brand: "ActronAir",
    brandLogo: "https://airconditioningguys.com.au/uploads/brand_logo/system-menu3.png",
    type: "ducted",
    model: "URC-071AS",
    image: "https://airconditioningguys.com.au/uploads/ac_product/image-20.png",
    capacity: "7.1 KW",
    badge: "BEST SELLER",
    capacityOptions: ["7.1 KW", "10 KW", "12.5 KW"],
    outlets: "3x Round outlets",
    priceNote: "Pricing includes GST",
    terms: [
      "5 years warranty on parts and labour.",
      "Standard Home requirements, Single story home, Pitch roof, Standard gyprock ceilings.",
      "Outdoor unit positioned on pvc slab, pvc mounting blocks, or rubber feet.",
      "ACG offer 5 year installation warranty.",
      "Sydney metro.",
      "Power included.",
      "Electrical Work Required May Incur Addition Costs",
    ],
  },
  {
    brand: "Samsung",
    brandLogo: "https://airconditioningguys.com.au/uploads/brand_logo/system-menu5.png",
    type: "ducted",
    model: "ACO71TNHDKG/SA",
    image: "https://airconditioningguys.com.au/uploads/ac_product/image-18.png",
    capacity: "7.1 KW",
    badge: "BEST SELLER",
    capacityOptions: ["7.1 KW", "10 KW", "12.5 KW", "14 KW", "16 KW"],
    outlets: "3x Round outlets",
    priceNote: "Pricing includes GST",
    terms: [
      "5 years warranty on parts and labour.",
      "Standard Home requirements, Single story home, Pitch roof, Standard gyprock ceilings.",
      "Outdoor unit positioned on pvc slab, pvc mounting blocks, or rubber feet.",
      "ACG offer 5 year installation warranty.",
      "Sydney metro.",
      "Power included.",
      "Electrical Work Required May Incur Addition Costs",
    ],
  },
  {
    brand: "LG",
    brandLogo: "https://airconditioningguys.com.au/uploads/brand_logo/system-menu6.png",
    type: "ducted",
    model: "B30AWY-7G6",
    image: "https://airconditioningguys.com.au/uploads/ac_product/image-24.png",
    capacity: "8.1 KW",
    badge: "BEST SELLER",
    capacityOptions: ["8.1 KW", "10.5 KW", "12.5 KW", "15 KW"],
    outlets: "5-6x Round outlets 2x zones",
    priceNote: "Pricing includes GST",
    terms: [
      "5 years warranty on parts and labour.",
      "Standard Home requirements, Single story home, Pitch roof, Standard gyprock ceilings.",
      "Outdoor unit positioned on pvc slab, pvc mounting blocks, or rubber feet.",
      "ACG offer 5 year installation warranty.",
      "Sydney metro.",
      "Power included.",
      "Electrical Work Required May Incur Addition Costs.",
    ],
  },
  {
    brand: "Mitsubishi",
    brandLogo: "https://airconditioningguys.com.au/uploads/brand_logo/system-menu2.png",
    type: "ducted",
    model: "PEARP100GAAVKIT",
    image: "https://airconditioningguys.com.au/uploads/ac_product/image-23_001.png",
    capacity: "10 KW",
    badge: "BEST SELLER",
    capacityOptions: ["10 KW", "12.5 KW", "13.5 KW", "16 KW"],
    outlets: "4x Round outlets",
    priceNote: "Price Include GST",
    terms: [
      "5 years warranty on parts and labour.",
      "Standard Home requirements, Single story home, Pitch roof, Standard gyprock ceilings.",
      "Outdoor unit positioned on pvc slab, pvc mounting blocks, or rubber feet.",
      "ACG offer 5 year installation warranty.",
      "Sydney metro.",
      "Power included.",
      "Electrical Work Required May Incur Addition Costs",
    ],
  },
  // SPLIT SYSTEMS
  {
    brand: "Fujitsu",
    brandLogo: "https://airconditioningguys.com.au/uploads/brand_logo/system-menu4.png",
    type: "split",
    model: "ASTG09KMTC",
    image: "https://airconditioningguys.com.au/uploads/ac_product/special_fujitsuac.png",
    capacity: "2.5 KW",
    capacityOptions: ["2.5 KW", "3.5 KW", "5.0 KW", "6.0 KW", "7.1 KW"],
    oldPrice: "$2,229",
    newPrice: "$1,949",
    suitableFor: "Suitable for a small bedroom between 10-25 sqm",
    priceNote: "Pricing includes GST",
    terms: [
      "Back to back Installation.",
      "5 years warranty on parts and labour.",
      "Outdoor unit positioned on PVC slab.",
      "3 meters of refrigeration piping between indoor & outdoor.",
      "1 Length of 2.4 Metre PVC Duct or Colourbond.",
      "ACG offers 5 year installation warranty.",
      "Sydney metro.",
      "Electrical Work Required May Incur Addition Costs",
    ],
  },
  {
    brand: "ActronAir",
    brandLogo: "https://airconditioningguys.com.au/uploads/brand_logo/system-menu3.png",
    type: "split",
    model: "WRC-026CS",
    image: "https://airconditioningguys.com.au/uploads/ac_product/special_actronairac.png",
    capacity: "2.6 KW",
    badge: "BEST SELLER",
    capacityOptions: ["2.6 KW", "3.5 KW", "5.0 KW", "7.2 KW", "8.5 KW"],
    oldPrice: "$2,099",
    newPrice: "$1,799",
    suitableFor: "Suitable for a small bedroom between 10-25 sqm",
    priceNote: "Pricing includes GST",
    terms: [
      "Back to back Installation.",
      "5 years warranty on parts and labour.",
      "Outdoor unit positioned on PVC slab.",
      "3 meters of refrigeration piping between indoor & outdoor.",
      "1 Length of 2.4 Metre PVC Duct or Colourbond.",
      "ACG offers 5 year installation warranty.",
      "Sydney metro.",
      "Electrical Work Required May Incur Addition Costs",
    ],
  },
  {
    brand: "Rinnai",
    brandLogo: "https://airconditioningguys.com.au/uploads/brand_logo/ezgif-4-70296ffcef_006.png",
    type: "split",
    model: "HSNRT25B",
    image: "https://airconditioningguys.com.au/uploads/ac_product/ss23.png",
    capacity: "2.5 KW",
    capacityOptions: ["2.5 KW", "3.5 KW", "5.0 KW", "7.0 KW", "8.0 KW"],
    oldPrice: "$1,989",
    newPrice: "$1,749",
    suitableFor: "Suitable for a small bedroom between 10-25 sqm",
    priceNote: "Pricing includes GST",
    terms: [
      "Back to back Installation.",
      "5 years warranty on parts and labour.",
      "Outdoor unit positioned on PVC slab.",
      "3 meters of refrigeration piping between indoor & outdoor.",
      "1 Length of 2.4 Metre PVC Duct or Colourbond.",
      "ACG offers 5 year installation warranty.",
      "Sydney metro.",
      "Electrical Work Required May Incur Addition Costs",
    ],
  },
  {
    brand: "Daikin",
    brandLogo: "https://airconditioningguys.com.au/uploads/brand_logo/acg_partner1.png",
    type: "split",
    model: "FTXF25WVMA",
    image: "https://airconditioningguys.com.au/uploads/ac_product/special_daikinac_002.png",
    capacity: "2.5 KW",
    capacityOptions: ["2.5 KW", "3.5 KW", "5.0 KW", "6.2 KW", "7.1 KW"],
    oldPrice: "$2,489",
    newPrice: "$1,999",
    suitableFor: "Suitable for a small bedroom between 10-25 sqm",
    priceNote: "Pricing includes GST",
    terms: [
      "Back to back Installation.",
      "5 years warranty on parts and labour.",
      "Outdoor unit positioned on PVC slab.",
      "3 meters of refrigeration piping between indoor & outdoor.",
      "1 Length of 2.4 Metre PVC Duct or Colourbond.",
      "ACG offers 5 year installation warranty.",
      "Sydney metro.",
      "Electrical Work Required May Incur Addition Costs",
    ],
  },
  // MULTI-SPLIT SYSTEMS
  {
    brand: "Multi-Split",
    brandLogo: "",
    type: "multi",
    model: "Wall Mount",
    image: "https://airconditioningguys.com.au/uploads/ac_product/multisplit1.png",
    capacity: "",
    capacityOptions: [],
    newPrice: "Price On Request",
    terms: [],
  },
  {
    brand: "Multi-Split",
    brandLogo: "",
    type: "multi",
    model: "Outdoor Unit",
    image: "https://airconditioningguys.com.au/uploads/ac_product/multisplit2.png",
    capacity: "",
    capacityOptions: [],
    newPrice: "Price On Request",
    terms: [],
  },
  {
    brand: "Multi-Split",
    brandLogo: "",
    type: "multi",
    model: "Compact Casette",
    image: "https://airconditioningguys.com.au/uploads/ac_product/multisplit3.png",
    capacity: "",
    capacityOptions: [],
    newPrice: "Price On Request",
    terms: [],
  },
  {
    brand: "Multi-Split",
    brandLogo: "",
    type: "multi",
    model: "Bulkhead",
    image: "https://airconditioningguys.com.au/uploads/ac_product/multisplit4.png",
    capacity: "",
    capacityOptions: [],
    newPrice: "Price On Request",
    terms: [],
  },
];
